import { BigNumber } from 'bignumber.js'

import { Data } from '@blade/std-lib'
import { CurrencyAddress } from '@root/entities/currency'
import { Network } from '@root/entities/network'
import { PairAddress } from '@root/entities/pair'

import { FavoriteId } from './favorite-id'

import type { UnavailableFavoritePairDto } from '@root/shared/api/UserApi'

export interface FavoriteQuoteTokenMeta {
  address: CurrencyAddress
  name: string
  symbol: string
  decimals: number
  network: Network.Network
}
export interface FavoriteUserPosition {
  boughtSizeUSD: BigNumber
  boughtSizeNative: BigNumber
  boughtSizeTokens: BigNumber
  boughtTransactions: number
  soldSizeUSD: BigNumber
  soldSizeNative: BigNumber
  soldSizeTokens: BigNumber
  soldTransactions: number
  remainingSizeTokens: BigNumber
  pnl: FavoriteUserPositionPnl
}
export interface FavoriteUserPositionPnl {
  pnlNative: BigNumber
  pnlUsd: BigNumber
  pnlPercent: BigNumber
}

export class FavoriteUnavailable extends Data.TaggedClass(
  'FavoriteUnavailable',
)<{
  favoriteId: FavoriteId
  address: PairAddress
  baseTokenAddress: CurrencyAddress
  indexPosition: number
  quoteTokenMeta: FavoriteQuoteTokenMeta | undefined
  userPosition: FavoriteUserPosition | undefined
}> {
  static fromDto(dto: UnavailableFavoritePairDto): FavoriteUnavailable {
    return new FavoriteUnavailable({
      favoriteId: FavoriteId(dto.favoriteId),
      address: PairAddress(dto.pairAddress),
      baseTokenAddress: CurrencyAddress(dto.baseTokenAddress),
      indexPosition: dto.indexPosition,
      userPosition: dto.userPosition
        ? {
            boughtSizeUSD: BigNumber(dto.userPosition.boughtSizeUSD),
            boughtSizeNative: BigNumber(dto.userPosition.boughtSizeNative),
            boughtSizeTokens: BigNumber(dto.userPosition.boughtSizeTokens),
            boughtTransactions: dto.userPosition.boughtTransactions,
            soldSizeUSD: BigNumber(dto.userPosition.soldSizeUSD),
            soldSizeNative: BigNumber(dto.userPosition.soldSizeNative),
            soldSizeTokens: BigNumber(dto.userPosition.soldSizeTokens),
            soldTransactions: dto.userPosition.soldTransactions,
            remainingSizeTokens: BigNumber(
              dto.userPosition.remainingSizeTokens,
            ),
            pnl: {
              pnlNative: BigNumber(dto.userPosition.pnl.pnlNative),
              pnlUsd: BigNumber(dto.userPosition.pnl.pnlUsd),
              pnlPercent: BigNumber(dto.userPosition.pnl.pnlPercent),
            },
          }
        : undefined,
      quoteTokenMeta: dto.quoteTokenMeta
        ? {
            address: CurrencyAddress(dto.quoteTokenMeta.address),
            name: dto.quoteTokenMeta.name,
            symbol: dto.quoteTokenMeta.symbol,
            decimals: dto.quoteTokenMeta.decimals,
            network: Network.fromDto(dto.quoteTokenMeta.network),
          }
        : undefined,
    })
  }
}
